// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchOtherServicesTable, fetchOtherServiceById, addOtherService, updateOtherService, removeOtherService } from "../../api/otherServicesApi";

// Async thunks for Our service operations

export const getOtherServices = createAsyncThunk(
  "otherService/getOtherServices",
  async ({ page, limit, lan }: { page: number; limit: number; lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchOtherServicesTable(page, limit, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getOtherServiceById = createAsyncThunk(
  "otherService/getOtherServiceById",
  async ({ id, lan }: { id: string, lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchOtherServiceById(id, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createOtherService = createAsyncThunk(
  "otherService/createOtherService",
  async (newOtherService: {
    name: string; description: string; icon: string; order_type: string;
  }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addOtherService(newOtherService);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editOtherService = createAsyncThunk(
  "otherService/editOtherService",
  async ({ id, updatedOtherService, lan }: { id: string; updatedOtherService: { name: string; description: string; icon?: string; order_type: string; }; lan: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateOtherService(id, updatedOtherService, lan);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteOtherService = createAsyncThunk(
  "otherService/deleteOtherService",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeOtherService(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Other Service Slice

const otherServiceSlice = createSlice({
  name: "otherService",
  initialState: {
    otherServices: [] as any[],
    otherService: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all Other services
      .addCase(getOtherServices.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.otherServices = action.payload;
      })
      .addCase(getOtherServices.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Get Other service by ID
      .addCase(getOtherServiceById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.otherService = action.payload;
      })
      .addCase(getOtherServiceById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })

      // Create Other service
      .addCase(createOtherService.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.otherServices.push(action.payload);
          state.status = true;
          state.msg = "Other service created successfully.";
        } else {
          // // // console.log('Other service not an array');
        }
      })

      // Edit Other service
      .addCase(editOtherService.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.otherServices)) {
          const index = state.otherServices.findIndex((service) => service.id === id);
          if (index !== -1) {
            state.otherServices[index] = data;
          }
          state.status = true;
          state.msg = "Other service updated successfully.";
        } else {
          // // // console.log('Other service not an array');
        }
      })

      // Delete Other service
      .addCase(deleteOtherService.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.otherServices)) {
          state.otherServices = state.otherServices.filter((service) => service.id !== action.payload);
          state.status = true;
          state.msg = "Other service deleted successfully.";
        } else {
          // // // console.log('Other service not an array');
        }
      });
  },
});

export const { resetStatus } = otherServiceSlice.actions;
export default otherServiceSlice.reducer;
